import { isHourBetween } from '~/utils/date-time'

const dailyPeriod = {
  MORNING: 'MORNING',
  AFTERNOON: 'AFTERNOON',
  NIGHT: 'NIGHT',
}

const getCurrentPeriod = () => {
  if (isHourBetween(12, 18)) return dailyPeriod.AFTERNOON
  if (isHourBetween(19, 23)) return dailyPeriod.NIGHT
  return dailyPeriod.MORNING
}

export { getCurrentPeriod }
